export default "__VITE_ASSET__jDWp8HfG__"